import { prefixes } from "../../data/crm";
import { useCrmStore } from "../../stores/crm";
import { Input } from "../ui/inputs/Input";
import { Select } from "../ui/inputs/Select";

const PersonnePhysique = () => {
  const { formData, setFormData } = useCrmStore();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="w-full h-auto bg-white flex">
      <Input
        label="Numéro de dossier"
        name="number"
        value={formData.number || ""}
        onChange={handleChange}
        clasName="w-1/2 mr-4"
      />
      <Select
        label="Préfixe"
        name="prefix"
        value={formData.prefix || ""}
        onChange={handleSelectChange}
        fetchOptions={prefixes}
        className="w-2/3"
      />
      <Input
        label="Nom"
        name="lastName"
        value={formData.lastName || ""}
        onChange={handleChange}
        clasName="w-1/3 mr-4"
      />
      <Input
        label="Prénom"
        name="firstName"
        value={formData.firstName || ""}
        onChange={handleChange}
        clasName="w-1/3 mr-4"
      />
    </div>
  );
};

export default PersonnePhysique;
